export const GET_ACCS_AND_TOKEN = 'get_accs_and_token';
export const GET_ACCS_AND_TOKEN_SUCCESSFUL = 'get_accs_and_token_successful';
export const GET_ACCS_AND_TOKEN_FAILED = 'get_accs_and_token_failed';

export const GET_TAB_TOKEN = 'get_tab_token';
export const GET_TAB_TOKEN_SUCCESSFUL = 'get_tab_token_successful';
export const GET_TAB_TOKEN_FAILED = 'get_tab_token_failed';

export const CLEAR_TAB_TOKEN = "clear_tab_token";
export const CLEAR_TAB_TOKEN_SUCCESSFUL = "clear_tab_token_successful";